import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.parse-int.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { handle, hashCode } from "@dp/common";
import CacheConfig, { CACHE_TYPE } from "./cache_config";

function cacheAdapter(cacheEntry) {
  return function (config) {
    return cacheAdapterIntern(cacheEntry, config);
  };
}

function cacheAdapterIntern(_x, _x2) {
  return _cacheAdapterIntern.apply(this, arguments);
}

function _cacheAdapterIntern() {
  _cacheAdapterIntern = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cacheEntry, config) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            response = cacheEntry.response;
            response.headers.CACHED = true;
            response.config = config;
            return _context.abrupt("return", response);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _cacheAdapterIntern.apply(this, arguments);
}

export function lookupCache(_x3, _x4) {
  return _lookupCache.apply(this, arguments);
}

function _lookupCache() {
  _lookupCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(config, platformUtil) {
    var method, apiId, policyEntry, params, postData, key, _ref, _ref2, err, cacheEntryStr;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            method = config.method ? config.method.toLowerCase() : config.method;
            apiId = config.headers["X-API-ID"];
            policyEntry = CacheConfig.POLICIES[apiId];

            if (!(policyEntry && policyEntry.methods.indexOf(method) >= 0)) {
              _context2.next = 27;
              break;
            }

            params = config.params;
            postData = config.data;
            key = policyEntry.keyFn ? [apiId, policyEntry.keyFn(config)].join(":") : [apiId, hashCode(params) + (postData ? ":" + hashCode(postData) : "")].join(":");

            if (!(policyEntry.cacheType === CACHE_TYPE.LOCAL)) {
              _context2.next = 13;
              break;
            }

            _context2.next = 10;
            return handle(platformUtil.getFromLocalStorage(key));

          case 10:
            _context2.t0 = _context2.sent;
            _context2.next = 16;
            break;

          case 13:
            _context2.next = 15;
            return handle(platformUtil.getFromSessionStorage(key));

          case 15:
            _context2.t0 = _context2.sent;

          case 16:
            _ref = _context2.t0;
            _ref2 = _slicedToArray(_ref, 2);
            err = _ref2[0];
            cacheEntryStr = _ref2[1];

            if (!err) {
              _context2.next = 24;
              break;
            }

            return _context2.abrupt("return", null);

          case 24:
            return _context2.abrupt("return", processCacheEntry(key, cacheEntryStr, platformUtil, policyEntry.cacheType));

          case 25:
            _context2.next = 28;
            break;

          case 27:
            return _context2.abrupt("return", null);

          case 28:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _lookupCache.apply(this, arguments);
}

function processCacheEntry(_x5, _x6, _x7, _x8) {
  return _processCacheEntry.apply(this, arguments);
}

function _processCacheEntry() {
  _processCacheEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key, cacheEntryStr, platformUtil, cacheType) {
    var cacheEntry, expiryTime, currentTimeStamp;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!cacheEntryStr) {
              _context3.next = 18;
              break;
            }

            cacheEntry = JSON.parse(cacheEntryStr);
            expiryTime = cacheEntry.expiryTime;
            currentTimeStamp = Math.floor(Date.now());

            if (!(currentTimeStamp > expiryTime)) {
              _context3.next = 15;
              break;
            }

            if (!(cacheType === CACHE_TYPE.LOCAL)) {
              _context3.next = 10;
              break;
            }

            _context3.next = 8;
            return handle(platformUtil.clearLocalStorage([key, [key, "EXPIRY"].join(":")]));

          case 8:
            _context3.next = 12;
            break;

          case 10:
            _context3.next = 12;
            return handle(platformUtil.clearSessionStorage([key, [key, "EXPIRY"].join(":")]));

          case 12:
            return _context3.abrupt("return", null);

          case 15:
            return _context3.abrupt("return", cacheEntry);

          case 16:
            _context3.next = 19;
            break;

          case 18:
            return _context3.abrupt("return", null);

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _processCacheEntry.apply(this, arguments);
}

export function wrapCacheAdapter(_x9, _x10) {
  return _wrapCacheAdapter.apply(this, arguments);
}

function _wrapCacheAdapter() {
  _wrapCacheAdapter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(cacheEntry, config) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (cacheEntry) {
              config.adapter = cacheAdapter(cacheEntry);
            }

            return _context4.abrupt("return", config);

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _wrapCacheAdapter.apply(this, arguments);
}

export function clearExpiredCacheEntries(_x11) {
  return _clearExpiredCacheEntries.apply(this, arguments);
}

function _clearExpiredCacheEntries() {
  _clearExpiredCacheEntries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(platformUtil) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return handle(clearExpiredSessionStorageCacheEntries(platformUtil));

          case 2:
            _context5.next = 4;
            return handle(clearExpiredLocalStorageCacheEntries(platformUtil));

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _clearExpiredCacheEntries.apply(this, arguments);
}

function clearExpiredSessionStorageCacheEntries(_x12) {
  return _clearExpiredSessionStorageCacheEntries.apply(this, arguments);
}

function _clearExpiredSessionStorageCacheEntries() {
  _clearExpiredSessionStorageCacheEntries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(platformUtil) {
    var _yield$handle, _yield$handle2, err, sessionStoreKeys, expireKeys, _yield$handle3, _yield$handle4, err1, expireKeyValRecords, keysToClear;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return handle(platformUtil.getSessionStorageKeys());

          case 2:
            _yield$handle = _context6.sent;
            _yield$handle2 = _slicedToArray(_yield$handle, 2);
            err = _yield$handle2[0];
            sessionStoreKeys = _yield$handle2[1];

            if (!(err || !sessionStoreKeys)) {
              _context6.next = 8;
              break;
            }

            return _context6.abrupt("return");

          case 8:
            expireKeys = sessionStoreKeys.reduce(function (prev, key) {
              if (key.indexOf(":EXPIRY") > 0) {
                prev.push(key);
              }

              return prev;
            }, []);

            if (!(expireKeys.length <= 0)) {
              _context6.next = 11;
              break;
            }

            return _context6.abrupt("return");

          case 11:
            _context6.next = 13;
            return handle(platformUtil.multiGetFromSessionStorage(expireKeys));

          case 13:
            _yield$handle3 = _context6.sent;
            _yield$handle4 = _slicedToArray(_yield$handle3, 2);
            err1 = _yield$handle4[0];
            expireKeyValRecords = _yield$handle4[1];

            if (!(err1 || !expireKeyValRecords)) {
              _context6.next = 19;
              break;
            }

            return _context6.abrupt("return");

          case 19:
            keysToClear = getExpiredKeys(expireKeyValRecords);
            console.log("=========== Clear Session Storage for keys");
            console.log(keysToClear);

            if (!((keysToClear === null || keysToClear === void 0 ? void 0 : keysToClear.length) > 0)) {
              _context6.next = 25;
              break;
            }

            _context6.next = 25;
            return handle(platformUtil.clearSessionStorage(keysToClear));

          case 25:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _clearExpiredSessionStorageCacheEntries.apply(this, arguments);
}

function clearExpiredLocalStorageCacheEntries(_x13) {
  return _clearExpiredLocalStorageCacheEntries.apply(this, arguments);
}

function _clearExpiredLocalStorageCacheEntries() {
  _clearExpiredLocalStorageCacheEntries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(platformUtil) {
    var _yield$handle5, _yield$handle6, err, localStoreKeys, expireKeys, _yield$handle7, _yield$handle8, err1, expireKeyValRecords, keysToClear;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return handle(platformUtil.getLocalStorageKeys());

          case 2:
            _yield$handle5 = _context7.sent;
            _yield$handle6 = _slicedToArray(_yield$handle5, 2);
            err = _yield$handle6[0];
            localStoreKeys = _yield$handle6[1];

            if (!(err || !localStoreKeys)) {
              _context7.next = 8;
              break;
            }

            return _context7.abrupt("return");

          case 8:
            expireKeys = localStoreKeys.reduce(function (prev, key) {
              if (key.indexOf(":EXPIRY") > 0) {
                prev.push(key);
              }

              return prev;
            }, []);

            if (!(expireKeys.length <= 0)) {
              _context7.next = 11;
              break;
            }

            return _context7.abrupt("return");

          case 11:
            _context7.next = 13;
            return handle(platformUtil.multiGetFromLocalStorage(expireKeys));

          case 13:
            _yield$handle7 = _context7.sent;
            _yield$handle8 = _slicedToArray(_yield$handle7, 2);
            err1 = _yield$handle8[0];
            expireKeyValRecords = _yield$handle8[1];

            if (!(err1 || !expireKeyValRecords)) {
              _context7.next = 19;
              break;
            }

            return _context7.abrupt("return");

          case 19:
            keysToClear = getExpiredKeys(expireKeyValRecords);

            if (!(keysToClear && keysToClear.length)) {
              _context7.next = 23;
              break;
            }

            _context7.next = 23;
            return handle(platformUtil.clearLocalStorage(keysToClear));

          case 23:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _clearExpiredLocalStorageCacheEntries.apply(this, arguments);
}

function getExpiredKeys(expireKeyValRecords) {
  var currentTimeStamp = Math.floor(Date.now());
  return expireKeyValRecords.reduce(function (prev, expireKeyValRecord) {
    var key = expireKeyValRecord[0];
    var valStr = expireKeyValRecord[1];
    var apiCacheKey = key.substring(0, key.indexOf(":EXPIRY"));

    try {
      var val = parseInt(valStr);

      if (currentTimeStamp > val) {
        prev.push(apiCacheKey);
        prev.push(key);
      }
    } catch (e) {
      prev.push(apiCacheKey);
      prev.push(key);
    }

    return prev;
  }, []);
}

export function cacheResponse(_x14, _x15) {
  return _cacheResponse.apply(this, arguments);
}

function _cacheResponse() {
  _cacheResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(response, platformUtil) {
    var config, method, apiId, policyEntry, respHeaders, cached, params, postData, key, currentTimeStamp, expiryTime, cacheEntry;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            config = response.config;
            method = config.method ? config.method.toLowerCase() : config.method;
            apiId = config.headers["X-API-ID"];
            policyEntry = CacheConfig.POLICIES[apiId];
            respHeaders = response.headers;
            cached = respHeaders.CACHED;

            if (!(policyEntry && policyEntry.methods.indexOf(method) >= 0 && policyEntry.ttl && !cached)) {
              _context8.next = 24;
              break;
            }

            params = config.params;
            postData = config.data;
            key = policyEntry.keyFn ? [apiId, policyEntry.keyFn(config)].join(":") : [apiId, hashCode(params) + (postData ? ":" + hashCode(postData) : "")].join(":");
            currentTimeStamp = Math.floor(Date.now());
            expiryTime = currentTimeStamp + policyEntry.ttl;
            cacheEntry = {
              expiryTime: expiryTime,
              response: {
                data: response.data,
                status: response.status,
                statusText: response.statusText,
                headers: response.headers,
                config: null
              }
            };

            if (!(policyEntry.cacheType === CACHE_TYPE.LOCAL)) {
              _context8.next = 20;
              break;
            }

            _context8.next = 16;
            return handle(platformUtil.saveInLocalStorage(key, JSON.stringify(cacheEntry)));

          case 16:
            _context8.next = 18;
            return handle(platformUtil.saveInLocalStorage([key, "EXPIRY"].join(":"), [expiryTime, ""].join("")));

          case 18:
            _context8.next = 24;
            break;

          case 20:
            _context8.next = 22;
            return handle(platformUtil.saveInSessionStorage(key, JSON.stringify(cacheEntry)));

          case 22:
            _context8.next = 24;
            return handle(platformUtil.saveInSessionStorage([key, "EXPIRY"].join(":"), [expiryTime, ""].join("")));

          case 24:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _cacheResponse.apply(this, arguments);
}